import { VARIANTCHOOSER_RECEIVE } from '../Actions/VariantChooser.action';
 
export const variantChooser = (state = { variants: [] }, action) => {
    switch (action.type) {
        case VARIANTCHOOSER_RECEIVE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}